
import { useState } from "react";
import { CloseGreyIcon, CrossRed } from "../../../assets/icons";
import { planFeatureService } from "../../../services/planFeatureService";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";

interface AddPlanFeatureViewProps {
    onClose: () => void;
}

const AddPlanFeatureView: React.FC<AddPlanFeatureViewProps> = ({ onClose }) => {
    const [functionalityName, setFunctionalityName] = useState<string>("");
    const [key, setKey] = useState<string>("");
    const [functionalityNameError, setFunctionalityNameError] = useState<string>("");

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();

    const handleCreateFunctionality = async () => {

        if (functionalityName.trim() === "") {
            setFunctionalityNameError("Naziv funkcionalnosti je obavezan.");
            return;
        }

        setLoading(true);
        try {
            const response = await planFeatureService.createPlanFeature({
                name: functionalityName,
                key: key
            });

            if (response.success) {
                notify("success", response.message || "Funkcionalnost je uspešno kreirana.");
                onClose();
            }

        } catch (error: any) {
            notify("error", error.message || "Došlo je do greške prilikom kreiranja funkcionalnosti.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <section className="modal-section plan-func">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">
                                    <strong>Nova funkcionalnost</strong>
                                </div>
                                <div className="description-text">Kreirajte novu funkcionalnost plana</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">
                                <div className="modal-form-div">
                                    <label className="modal-form-label">
                                        <strong>Key value</strong>
                                    </label>
                                    <div className="div-block-32">
                                        <input className="form-input w-input" placeholder="" type="text" required
                                            value={key}
                                            onChange={(e) => setKey(e.target.value)}
                                        />
                                    </div>
                                    <div className="error-text margin-top--5px">{functionalityNameError}</div>
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">
                                        <strong>Naziv funkcionalnosti</strong>
                                    </label>
                                    <div className="div-block-32">
                                        <input className="form-input w-input" placeholder="" type="text" required
                                            value={functionalityName}
                                            onChange={(e) => setFunctionalityName(e.target.value)}
                                        />
                                    </div>
                                    <div className="error-text margin-top--5px">{functionalityNameError}</div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={handleCreateFunctionality}>
                                <div>Dodaj funkcionalnost</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default AddPlanFeatureView;